import utils from '@/mixins/utils'

export function filtro(
  cadastros,
  exibirVermelhos,
  exibirVerdes,
  selectedFilterBoasPraticas
) {
  let cadastros_filtrados = cadastros

  if (
    selectedFilterBoasPraticas == null ||
    selectedFilterBoasPraticas.value == null
  ) {
    if (exibirVermelhos === true) {
      cadastros_filtrados = cadastros_filtrados.filter((item) => {
        if (item.total_bp < 100) {
          item.rowColor = 'red'
          return true
        }
        return false
      })
    } else if (exibirVerdes === true) {
      cadastros_filtrados = cadastros_filtrados.filter((item) => {
        if (item.total_bp == 100) {
          item.rowColor = 'green'
          return true
        }
        return false
      })
    } else {
      // caso neutro: sem filtro ativo → todos passam com a cor correspondente
      cadastros_filtrados = cadastros_filtrados.filter((item) => {
        if (item.total_bp == 100) {
          item.rowColor = 'green'
        } else {
          item.rowColor = 'red'
        }
        return true
      })
    }
  } else {
    cadastros_filtrados = filterByBoaPratica(
      cadastros_filtrados,
      selectedFilterBoasPraticas,
      exibirVermelhos,
      exibirVerdes
    )
  }

  return cadastros_filtrados
}

function filterByBoaPratica(cadastros, bp, exibirVermelhos, exibirVerdes) {
  const regras = {
    'colo-utero': { campo: 'a_pb', min: 25, max: 64 },
    vacinas: { campo: 'b_pb', min: 9, max: 14 },
    consultas: { campo: 'c_pb', min: 14, max: 69 },
    mama: { campo: 'd_pb', min: 50, max: 69 },
  }

  const regra = regras[bp?.key]
  if (!regra) return cadastros

  return cadastros.filter((el) => {
    const idade = Number(el?.idade_fim_quad)
    const valor = Number(el?.[regra.campo])

    // fora da faixa de idade, descarta
    if (!Number.isFinite(idade) || idade < regra.min || idade > regra.max) {
      return false
    }

    // vermelho
    if (exibirVermelhos) {
      if (valor == null || valor === 0) {
        el.rowColor = 'red'
        return true
      }
      return false
    }

    // verde
    if (exibirVerdes) {
      if (valor != null && valor > 0) {
        el.rowColor = 'green'
        return true
      }
      return false
    }

    // neutro: considera válido se valor > 0
    if (valor != null && valor > 0) {
      el.rowColor = 'green'
      return true
    }

    el.rowColor = 'red'
    return true
  })
}
